import { TFunction } from 'react-i18next'

export interface Form {
    startDate?: string
}

export const validate = async (values: Form, t: TFunction<'translation'>) => {
    const errors: Partial<Form> = {}
    if (!values.startDate) {
        errors.startDate = `${t('LABEL.SELECT_REQUIRED')}` as any
    }
    return errors
}

const useDatePicker = () => {
    const handleSubmit = (values: any) => {
        console.log('date picker submit', values)
    }

    return {
        onSubmit: handleSubmit,
    }
}

export default useDatePicker
